import React, { useCallback, useEffect } from "react";
import DataGrid, { Column, Paging } from "devextreme-react/data-grid";
import { useDispatch, useSelector } from "react-redux";
import {
  getResourceState,
  getResourceAPI,
} from "../../redux/slices/resourceSlice.js";
import { getUIProperty, setUIProperty } from "../../redux/slices/uiSlice.js";
import DateDisplay from "../generic/DateDisplay";
import TradeCaseControls from "./TradeCaseControls.jsx";
import useResourceStatuses from "../../hooks/useResourceStatus.jsx";
import SalesPerson from "../generic/SalesPerson.jsx";
import Loader from "../generic/Loader.jsx";
import { useRef } from "react";
import { Redirect } from "react-router-dom";
import { fromCustomDate } from "../../utils/date";

const columns = [
  { dataField: "id", caption: "Our Ref", width: 70 },
  { dataField: "date", caption: "Date", width: "", cellRender: DateDisplay },
  { dataField: "client_ref", caption: "Client Ref", width: 150 },
  { dataField: "client_name", caption: "Client Name", width: 150 },
  { dataField: "vessel_name", caption: "Vessel", width: "" },
  {
    dataField: "client_employee_name",
    caption: "Client Employee",
  },
  {
    dataField: "employee_name",
    caption: "Sales Person",
    width: 150,
    cellRender: (data) => <SalesPerson data={data} />,
  },
  { dataField: "status", caption: "Status", width: 70 },
  { dataField: "state", caption: "State", width: "" },
  { dataField: "urgency", caption: "Urgency", with: 70 },
  { dataField: "urgent_period", caption: "Urgent Period", with: 70 },
];

const defaultPageSize = 5;

const TradeCasesGrid = () => {
  const dispatch = useDispatch();
  const gridRef = useRef({});

  const { searchDetailsStatus, employeeStatus, searchStatus } =
    useResourceStatuses();

  const selectedTradeCaseId = useSelector((state) =>
    getUIProperty(state, "selectedTradeCaseId")
  );

  const tradeCases = useSelector((state) =>
    getResourceState(state, "trade_cases")
  );

  const onSelectionChanged = useCallback(
    ({ selectedRowsData }) => {
      const selectedRow = selectedRowsData[0];

      if (selectedRow)
        gridRef.current.instance.option("focusedRowKey", selectedRow.id);
        dispatch(
          setUIProperty({ name: "selectedTradeCaseId", value: selectedRow.id })
        );
    },
    [dispatch]
  );

  const onOptionChanged = useCallback(
    (e) => {
      let efullName = e.fullName;
      if (efullName === "paging.pageIndex" || efullName.endsWith("sortOrder")) {
        const dataGrid = e.component;
        const keys = dataGrid.getSelectedRowKeys();
        //dataGrid.deselectRows(keys);

        const pageIndex = e.value;

        const firstVisibleCase = tradeCases[defaultPageSize * pageIndex];
        gridRef.current.instance.option("focusedRowIndex", 0);
        dispatch(
          setUIProperty({
            name: "selectedTradeCaseId",
            value: firstVisibleCase.id,
          })
        );
      }
    },
    [dispatch, tradeCases]
  );

  const cellPrepared = (e) => {

    if (e.rowType === "data") {
        if (e.column.dataField === "urgent_period" && e.data.urgent_period > 0){
          const nowDate = new Date();
          const tcDate = fromCustomDate(e.data.date);

          const dateDiff = nowDate.getDate() - tcDate.getDate();
          const timeLeft = e.data.urgent_period - dateDiff;

          if(timeLeft > 10) {
            e.cellElement.style.cssText = "color: white; background-color: green";
            e.cellElement.classList.add("my-class");
          } else if( timeLeft <= 10 && timeLeft >= 3){
            e.cellElement.style.cssText = "color: black; background-color: yellow";
            e.cellElement.classList.add("my-class");
          } else if( timeLeft < 3){
            e.cellElement.style.cssText = "color: white; background-color: red";
            e.cellElement.classList.add("my-class");
          }
        }
         
    }
  }
  useEffect(() => {
    if (searchStatus === "done" && tradeCases && tradeCases.length > 0) {
      gridRef.current.instance.option("focusedRowIndex", 0);
      dispatch(
        setUIProperty({
          name: "selectedTradeCaseId",
          value: (tradeCases[0] || { id: null }).id,
        })
      );
    }
  }, [dispatch, searchStatus, tradeCases]);

  useEffect(() => {
    employeeStatus === "idle" && dispatch(getResourceAPI({ path: "employee" }));
  }, [dispatch, employeeStatus]);

  useEffect(() => {
    if (selectedTradeCaseId) {
      console.log(selectedTradeCaseId);
      dispatch(
        getResourceAPI({
          path: "search-details",
          query: { trade_case_id: selectedTradeCaseId },
        })
      );
      
//      const tradeCaseIndex =
//        tradeCases.findIndex((tc) => tc.id === selectedTradeCaseId) % 5;

//      setTimeout(() => {
//        if (gridRef.current.instance) {
//          gridRef.current.instance.selectRowsByIndexes(tradeCaseIndex ?? 0);
//        }
//      }, 300);
    }
  }, [selectedTradeCaseId, dispatch, tradeCases]);

  return (
    <>
      {searchStatus === "idle" && <Redirect to="/admin/search" />}
      <TradeCaseControls disabled={searchDetailsStatus === "pending"} />
      {searchStatus === "pending" && <Loader />}
      <DataGrid
        id="gridContainer"
        keyExpr="id"
        rowAlternationEnabled={true}
        focusedRowEnabled={true}
        style={{ width: "100%", paddingTop: "8px", maxHeight: "270px" }}
        allowColumnResizing={true}
        allowColumnReordering={true}
        dataSource={tradeCases}
        showBorders={true}
        hoverStateEnabled={true}
        selection={{ mode: "single" }}
        onSelectionChanged={onSelectionChanged}
        onOptionChanged={onOptionChanged}
        onCellPrepared={cellPrepared}
        // onContentReady={onContentReady}
        ref={gridRef}
      >
        <Paging enabled={true} defaultPageSize={defaultPageSize} />
        {columns.map((column, idx) => (
          <Column
            key={idx}
            cellRender={column.cellRender}
            dataType={column.dataType}
            dataField={column.dataField}
            caption={column.caption}
            width={column.width}
          />
        ))}
      </DataGrid>
    </>
  );
};
export default TradeCasesGrid;
